import { WaitingRoomConnection } from "bouncer-waitingroom";
import { WaitingRoomHandler } from "./WaitingRoomHandler";

let wrc = new WaitingRoomConnection();
let wrh: WaitingRoomHandler;
wrc.startConnection();

async function createWaitingRoomHandler() {
    wrh = new WaitingRoomHandler();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", createWaitingRoomHandler);
} else {
    createWaitingRoomHandler();
}
